import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/api';

/**
 * Componente de rota protegida.
 * Redireciona para login se usuário não estiver autenticado.
 */
const PrivateRoute = ({ children }) => {
  const user = authService.getCurrentUser();

  if (!user.userId || !authService.isTokenValid()) {
    // Remove token expirado ou inválido do armazenamento local
    authService.logout();
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
